import http from '@/services/http'
import httpAuth from '@/services/httpAuth'

import { serialize2 } from '@/services/object'

export function login ({ email, senha, aplicacao }) {
  return http.post('/auth/login', { email, senha, aplicacao })
}

export function refresh ({ refreshToken }) {
  return http.post('/auth/refreshToken', { refreshToken })
}

export async function confirmaSenha (dados) {
  const token = await httpAuth.post('/auth/confirma-senha', dados)
  return token
}

export function logout ({ refreshToken }) {
  return http.post('/auth/logout', { refreshToken })
}

// Devices
export async function addDevice ({ device }) {
  return httpAuth.post('/device/device', device)
}

export async function editDevice (fingerprint, dados) {
  return httpAuth.put(`/auth/device/${fingerprint}`, dados, { funcionalidade: 'auth_device_editar' })
}

export async function getDevice (fingerprint) {
  return httpAuth.get(`/auth/device/${fingerprint}`)
}

export async function delDevice (fingerprint) {
  return httpAuth.delete(`/auth/device/${fingerprint}`, { tela: 'auth_device' })
}

// Logs
export async function listLogs (filtros) {
  return httpAuth.get(`/auth/logs/${serialize2(filtros)}`, { tela: 'auth_logs' })
}
